import { createContext } from "react";
import { AxiosRequestConfig } from "axios";
import { MisbilledTradeState, MismatchedTradeState } from "../../../types";

export const INITIAL_MISMATCHED_TRADES_STATE: MismatchedTradeState = {
  loadingMismatchedTrades: false,
  mismatchedRecordsCount: 0,
  records: [],
};

export const INITIAL_MISBILLED_TRADES_STATE: MisbilledTradeState = {
  loadingMisbilledTrades: false,
  records: [],
};

export interface SearchProps {
  mismatchedRecordState: MismatchedTradeState;
  misbilledRecordState: MisbilledTradeState;
  getMismatchedTrades: () => void;
  getMisbilledTrades: (
    startDate: string,
    endDate: string,
    config: AxiosRequestConfig
  ) => void;
}

export const SearchContext = createContext<SearchProps>({
  mismatchedRecordState: INITIAL_MISMATCHED_TRADES_STATE,
  misbilledRecordState: INITIAL_MISBILLED_TRADES_STATE,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getMismatchedTrades: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getMisbilledTrades: () => {},
});
